import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import clsx from 'clsx';
import React from 'react';
import { ModalOverlay, Modal, Dialog } from 'react-aria-components';
import { IconButton } from '../IconButton/IconButton.es.js';

const modalOverlay = "_modal-overlay_1kiwo_17";
const fadeIn = "_fade-in_1kiwo_1";
const fadeOut = "_fade-out_1kiwo_1";
const modal = "_modal_1kiwo_17";
const dialog = "_dialog_1kiwo_55";
const closeButton = "_close-button_1kiwo_68";
const styles = {
	modalOverlay: modalOverlay,
	fadeIn: fadeIn,
	fadeOut: fadeOut,
	modal: modal,
	dialog: dialog,
	closeButton: closeButton
};

const ModalContent = (_a) => {
  var { children, className, isDismissable = true } = _a, props = __rest(_a, ["children", "className", "isDismissable"]);
  return React.createElement(
    ModalOverlay,
    { className: styles.modalOverlay, "data-zds": true, isDismissable },
    React.createElement(
      Modal,
      { className: clsx(className, styles.modal), "data-zds": true, isDismissable },
      React.createElement(Dialog, Object.assign({}, props, { className: styles.dialog, "data-zds": true }), ({ close }) => React.createElement(
        React.Fragment,
        null,
        isDismissable && React.createElement(IconButton, { className: styles.closeButton, name: "formX", onPress: close, variant: "ghost" }),
        children
      ))
    )
  );
};

export { ModalContent };
//# sourceMappingURL=Content.es.js.map
